// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__GBKcJ","footer":"ModalUpdate_footer__3xrAd"};